import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e10e1e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "zusammenarbeitform" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_3 = { class: "row mt-5" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Projektzusammenarbeiten", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-4" }
const _hoisted_10 = { class: "col-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "col-12 mt-4" }
const _hoisted_14 = { class: "row mt-5" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Neues Projekt hinzufügen")
], -1))
const _hoisted_16 = { class: "col-3" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "col-12 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LabeledSelect = _resolveComponent("LabeledSelect")!
  const _component_LabeledInput = _resolveComponent("LabeledInput")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.zusammenarbeiten)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              (_ctx.zusammenarbeiten.length > 0)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_6, "Bearbeiten der Projekte"))
                : _createCommentVNode("", true)
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zusammenarbeiten, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: index
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_LabeledSelect, {
                  label: "User",
                  options: _ctx.users,
                  modelValue: item.userid,
                  "onUpdate:modelValue": ($event: any) => ((item.userid) = $event)
                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_LabeledInput, {
                  modelValue: item.text,
                  "onUpdate:modelValue": ($event: any) => ((item.text) = $event),
                  placeholder: "Projekt",
                  label: "Projekt"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_LabeledInput, {
                  modelValue: item.note,
                  "onUpdate:modelValue": ($event: any) => ((item.note) = $event),
                  placeholder: "Notiz",
                  label: "Notiz"
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("button", {
                  class: "delete",
                  onClick: ($event: any) => (_ctx.del(index))
                }, "Löschen", 8, _hoisted_11)
              ])
            ]))
          }), 128)),
          (_ctx.zusammenarbeiten.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
                  }, "Speichern")
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_LabeledSelect, {
                label: "User",
                options: _ctx.users,
                modelValue: _ctx.newproject.userid,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newproject.userid) = $event))
              }, null, 8, ["options", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_LabeledInput, {
                modelValue: _ctx.newproject.text,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newproject.text) = $event)),
                placeholder: "Projekt",
                label: "Projekt"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_LabeledInput, {
                modelValue: _ctx.newproject.note,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newproject.note) = $event)),
                placeholder: "Notiz",
                label: "Notiz"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args)))
              }, "Hinzufügen")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}